import { render } from "./ServiceRequestThanks.vue?vue&type=template&id=e67787da"
import script from "./ServiceRequestThanks.vue?vue&type=script&lang=js"
export * from "./ServiceRequestThanks.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__